/* Fragrance Lord search dropdown — talks to our own search service (fl_search_server.mjs on the VPS).
 * Attaches to every search form on the page, shows products, brands and notes as you type, and lets
 * Claude read natural-language searches ("fresh citrus for summer", "something like aventus").
 * Replaces the Searchanise widget (2026-10-20). No dependencies. */
(function () {
  "use strict";
  var API = "https://search.fragrancelord.com/fl/search";
  // Search API on its own name; the second address is tried only if the first cannot be reached (until DNS exists).
  var APIS = ["https://search.fragrancelord.com/fl/search", "https://fls-143-198-118-50.sslip.io/fl/search"];
  function get(url) { return fetch(url, { mode: "cors" }).catch(function (e) { if (url.indexOf(APIS[0]) === 0 && APIS[1]) { API = APIS[1]; return fetch(APIS[1] + url.slice(APIS[0].length), { mode: "cors" }); } throw e; }); }
  var MIN = 2, DEBOUNCE = 150, AI_DELAY = 650;
  var cache = {}, panel, active = null, timer = null, aiTimer = null, seq = 0;

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function money(n) { n = Number(n); return "$" + (Math.round(n * 100) / 100).toFixed(n % 1 ? 2 : 0); }
  function searchUrl(q) { return "/search?q=" + encodeURIComponent(q) + "&type=product"; }

  function ensurePanel() {
    if (panel) return panel;
    panel = el("div", "fls-panel"); panel.setAttribute("role", "region"); panel.setAttribute("aria-label", "Search suggestions"); panel.hidden = true;
    document.body.appendChild(panel);
    document.addEventListener("click", function (e) { if (!panel.contains(e.target) && !(active && active.form.contains(e.target))) hide(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") hide(); });
    window.addEventListener("resize", place); window.addEventListener("scroll", place, true);
    return panel;
  }
  function place() {
    if (!active || panel.hidden) return;
    var r = active.input.getBoundingClientRect(), vw = window.innerWidth, mobile = vw < 768;
    var width = mobile ? vw - 16 : Math.min(860, Math.max(560, r.width + 200)), left = mobile ? 8 : Math.max(8, Math.min(r.left, vw - width - 8));
    panel.style.left = left + "px"; panel.style.top = (r.bottom + 6) + "px"; panel.style.width = width + "px";
    panel.style.maxHeight = Math.max(240, window.innerHeight - r.bottom - 20) + "px";
  }
  function show() { ensurePanel(); panel.hidden = false; place(); }
  function hide() { if (panel) panel.hidden = true; }

  function fetchResults(q, ai) {
    var key = q.toLowerCase() + (ai ? "|ai" : "");
    if (cache[key]) return Promise.resolve(cache[key]);
    return get(API + "?q=" + encodeURIComponent(q) + "&limit=8" + (ai ? "" : "&ai=0"), { mode: "cors" })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { cache[key] = j; return j; });
  }

  function render(q, data, pending) {
    ensurePanel();
    var html = "";
    var products = data.products || [];
    html += '<div class="fls-cols">';
    html += '<div class="fls-side">';
    if (data.didYouMean) html += '<div class="fls-h">Did you mean</div><a class="fls-chip fls-dym" href="' + esc(searchUrl(data.didYouMean)) + '" data-q="' + esc(data.didYouMean) + '">' + esc(data.didYouMean) + '</a>';
    if (data.mode === "similar" && data.reference) html += '<div class="fls-h">Similar to</div><a class="fls-ref" href="' + esc(data.reference.url) + '">' + esc(data.reference.title) + '</a>';
    if (data.brands && data.brands.length) {
      html += '<div class="fls-h">Brands</div>';
      data.brands.forEach(function (b) { html += '<a class="fls-chip" href="' + esc(b.url) + '">' + esc(b.name) + ' <span>' + b.count + '</span></a>'; });
    }
    if (data.notes && data.notes.length) {
      html += '<div class="fls-h">Notes</div>';
      data.notes.forEach(function (n) { html += '<a class="fls-chip fls-note" href="' + esc(searchUrl(n)) + '" data-q="' + esc(n) + '">' + esc(n) + '</a>'; });
    }
    if (data.ai && (data.ai.notes || []).length) html += '<div class="fls-ai">Understood as: ' + esc((data.ai.notes || []).slice(0, 4).join(", ")) + (data.ai.gender ? " · " + esc(data.ai.gender) : "") + (data.ai.max_price ? " · under " + money(data.ai.max_price) : "") + '</div>';
    html += '</div>';
    html += '<div class="fls-main">';
    if (!products.length) {
      html += '<div class="fls-h">Products</div><div class="fls-empty">' + (pending ? "Thinking about that…" : 'Nothing found for <strong>' + esc(q) + '</strong>. Try a brand, a perfume name, or a note like vanilla or oud.') + '</div>';
    } else {
      html += '<div class="fls-h">Products' + (pending ? ' <span class="fls-pending">refining…</span>' : '') + '</div><ul class="fls-list">';
      products.forEach(function (p) {
        html += '<li><a class="fls-item" href="' + esc(p.url) + '">' +
          '<span class="fls-img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="fls-text"><span class="fls-title">' + esc(p.title) + '</span>' +
          '<span class="fls-meta">' + (p.vendor ? esc(p.vendor) + ' · ' : '') + (p.available ? '' : '<em>out of stock</em> · ') +
          (p.compareAt && p.compareAt > p.price ? '<s>' + money(p.compareAt) + '</s> ' : '') + money(p.price) + (p.priceMax > p.price ? ' – ' + money(p.priceMax) : '') +
          (p.sampleUrl ? ' · <span class="fls-sample">sample from ' + money(p.samplePrice) + '</span>' : '') + '</span></span></a></li>';
      });
      html += '</ul>';
    }
    html += '<a class="fls-all" href="' + esc(searchUrl(q)) + '">See all results for “' + esc(q) + '” →</a>';
    html += '</div></div>';
    panel.innerHTML = html;
    panel.querySelectorAll("[data-q]").forEach(function (a) { a.addEventListener("click", function (e) { e.preventDefault(); if (active) { active.input.value = a.getAttribute("data-q"); run(active, true); } }); });
    show();
  }

  function run(ctx, immediate) {
    var q = ctx.input.value.trim();
    clearTimeout(timer); clearTimeout(aiTimer);
    if (q.length < MIN) { hide(); return; }
    active = ctx;
    var my = ++seq;
    var go = function () {
      fetchResults(q, false).then(function (d) { if (my !== seq) return; var words = q.split(/\s+/).length; var wantAi = words >= 2 || d.total < 3; render(q, d, wantAi); if (wantAi) aiTimer = setTimeout(function () { fetchResults(q, true).then(function (d2) { if (my === seq) render(q, d2, false); }).catch(function () { if (my === seq) render(q, d, false); }); }, AI_DELAY); })
        .catch(function () { if (my === seq) hide(); });
    };
    if (immediate) go(); else timer = setTimeout(go, DEBOUNCE);
  }

  function attach(form) {
    var input = form.querySelector('input[name="q"]'); if (!input || input.dataset.flSearch) return;
    input.dataset.flSearch = "1"; input.setAttribute("autocomplete", "off");
    var ctx = { form: form, input: input };
    input.addEventListener("input", function () { run(ctx); });
    input.addEventListener("focus", function () { if (input.value.trim().length >= MIN) run(ctx, true); });
  }
  function init() { document.querySelectorAll('form[role="search"]').forEach(attach); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
